import React from "react";
import s from './connect-wallet.module.css';
import airdaoIcon from './assets/airdao-icon.svg';
import metamaskIcon from './assets/metamask.svg';
import walletConnectIcon from './assets/wallet-connect.svg';
import arrowIcon from './assets/arrow.svg';
import PropTypes from "prop-types";
export function ConnectWallet(_a) {
    var loginMetamask = _a.loginMetamask, loginWalletConnect = _a.loginWalletConnect;
    return (React.createElement("div", { className: s['login-modal'] },
        React.createElement("img", { src: airdaoIcon, width: "65", height: "65", alt: "login" }),
        React.createElement("p", { className: s['login-modal__subtitle'] }, "Connect a wallet to use AirDAO"),
        React.createElement("button", { className: s['login-modal__btn'], onClick: loginMetamask },
            React.createElement("img", { src: metamaskIcon, width: "28", height: "25", className: s['login-modal__img'], alt: "metamask" }),
            React.createElement("div", { className: s['login-modal__block'] },
                React.createElement("p", { className: s['login-modal__title'] }, "MetaMask"),
                React.createElement("p", { className: s['login-modal__text'] }, "Connect using your browser wallet")),
            React.createElement("img", { src: arrowIcon, width: "16", height: "16", className: s['login-modal__arrow'], alt: "arrow" })),
        React.createElement("button", { className: s['login-modal__btn'], onClick: loginWalletConnect },
            React.createElement("img", { src: walletConnectIcon, width: "28", height: "16", className: s['login-modal__img'], alt: "wallet connect" }),
            React.createElement("div", { className: s['login-modal__block'] },
                React.createElement("p", { className: s['login-modal__title'] }, "WalletConnect"),
                React.createElement("p", { className: s['login-modal__text'] }, "Connect using WalletConnect")),
            React.createElement("img", { src: arrowIcon, width: "16", height: "16", className: s['login-modal__arrow'], alt: "arrow" }))));
}
ConnectWallet.propTypes = {
    loginMetamask: PropTypes.func,
    loginWalletConnect: PropTypes.func,
};
//# sourceMappingURL=ConnectWallet.js.map